(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doctor_cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var wrapper = document.querySelector('.doctors-cards-wrapper');
    if (!wrapper) return;

    var cards = wrapper.querySelectorAll('.doctor-card');
    if (!cards.length) return;

    var paginationContainer = document.querySelector('.doctors-pagination');
    if (!paginationContainer) return;

    var prevBtn = paginationContainer.querySelector('.pagination-prev');
    var nextBtn = paginationContainer.querySelector('.pagination-next');
    var pagesWrapper = paginationContainer.querySelector('.pagination-pages');

    var desktopPerPage = parseInt(wrapper.getAttribute('data-desktop-per-page')) || 8;
    var mobilePerPage = parseInt(wrapper.getAttribute('data-mobile-per-page')) || 5;

    var currentPage = 1;
    var totalPages = 1;

    var section = wrapper.closest('.doctors-section') || wrapper;

    // 🔧 adjust this value to scroll more/less towards top
    var SCROLL_OFFSET = 150;

    function scrollToTop() {
      var top = section.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: top - SCROLL_OFFSET,
        behavior: 'smooth',
      });
    }

    function isMobile() {
      return window.innerWidth < 768;
    }

    function getPerPage() {
      return isMobile() ? mobilePerPage : desktopPerPage;
    }

    function updatePagination() {
      var perPage = getPerPage();
      totalPages = Math.ceil(cards.length / perPage);

      paginationContainer.style.display = totalPages <= 1 ? 'none' : 'flex';

      if (currentPage > totalPages) currentPage = totalPages || 1;

      cards.forEach(function (card, index) {
        var pageIndex = Math.floor(index / perPage) + 1;
        card.style.display = pageIndex === currentPage ? '' : 'none';
      });

      pagesWrapper.innerHTML = '';
      for (var i = 1; i <= totalPages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'pagination-page' + (i === currentPage ? ' is-active' : '');
        btn.textContent = i;

        (function (page) {
          btn.addEventListener('click', function () {
            currentPage = page;
            updatePagination();
            scrollToTop();
          });
        })(i);

        pagesWrapper.appendChild(btn);
      }

      prevBtn.disabled = currentPage === 1;
      nextBtn.disabled = currentPage === totalPages;
    }

    cards.forEach(function (card) {
      if (!card.classList.contains('has-link')) return;
      card.addEventListener('click', function (event) {
        if (event.defaultPrevented) return;
        if (event.target.closest('a, button')) return;

        var link = card.querySelector('.doctor-card-link');
        if (link && link.href) {
          window.location.href = link.href;
        }
      });
    });

    prevBtn.addEventListener('click', function () {
      if (currentPage > 1) {
        currentPage--;
        updatePagination();
        scrollToTop();
      }
    });

    nextBtn.addEventListener('click', function () {
      if (currentPage < totalPages) {
        currentPage++;
        updatePagination();
        scrollToTop();
      }
    });

    window.addEventListener('resize', function () {
      updatePagination();
    });

    updatePagination();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.scheduleFullLayoutUpdate = this.scheduleFullLayoutUpdate.bind(this);
      this.applyPermanentStickyState = this.applyPermanentStickyState.bind(this);
    }

    connectedCallback() {
      if (this.isInitialized) return;
      this.isInitialized = true;

      this.header = this.closest('.section-header') || document.querySelector('.section-header');
      if (!this.header) return;

      this.root = document.documentElement;
      this.announcementBar = document.querySelector('.announcement-bar-section');
      this.mobileBottomBar = document.querySelector('.fixed-icons');

      this.layoutFrame = null;
      this.lastAnnouncementHeight = -1;
      this.lastHeaderHeight = -1;
      this.lastMobileBottomBarHeight = -1;

      this.applyPermanentStickyState();
      this.updateFullLayout();

      /*
        Positioning itself is handled entirely by native CSS position: sticky
        (see the .section-header rules above) so it stays perfectly in sync
        with the browser's own scroll compositing - no scroll listener, no
        per-frame JS repositioning. Only the measured heights below (used by
        other components) need to be kept up to date, on resize/content
        changes rather than on every scroll frame.
      */
      window.addEventListener('resize', this.scheduleFullLayoutUpdate, { passive: true });
      window.addEventListener('load', this.scheduleFullLayoutUpdate, { once: true });
      document.addEventListener('shopify:section:load', this.scheduleFullLayoutUpdate);
      document.addEventListener('shopify:section:select', this.scheduleFullLayoutUpdate);
      this.addEventListener('preventHeaderReveal', this.applyPermanentStickyState);

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(this.scheduleFullLayoutUpdate);
        this.resizeObserver.observe(this.header);

        if (this.announcementBar) {
          this.resizeObserver.observe(this.announcementBar);
        }

        if (this.mobileBottomBar) {
          this.resizeObserver.observe(this.mobileBottomBar);
        }
      }

      if (this.announcementBar && 'MutationObserver' in window) {
        this.announcementObserver = new MutationObserver(this.scheduleFullLayoutUpdate);
        this.announcementObserver.observe(this.announcementBar, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden'],
          subtree: true
        });
      }

      document.fonts?.ready.then(this.scheduleFullLayoutUpdate).catch(() => {});
    }

    applyPermanentStickyState() {
      if (!this.header) return;

      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'animate',
        'scrolled-past-header'
      );
    }

    scheduleFullLayoutUpdate() {
      if (this.layoutFrame) return;

      this.layoutFrame = requestAnimationFrame(() => {
        this.layoutFrame = null;
        this.updateFullLayout();
      });
    }

    updateAnnouncementMeasurement() {
      const announcementHeight = Math.round(
        this.announcementBar?.offsetHeight || 0
      );

      if (announcementHeight === this.lastAnnouncementHeight) return;

      this.lastAnnouncementHeight = announcementHeight;
      this.root.style.setProperty(
        '--announcementBarHeight',
        `${announcementHeight}px`
      );
    }

    updateHeaderMeasurements() {
      const headerHeight = Math.ceil(this.header.getBoundingClientRect().height);

      if (headerHeight !== this.lastHeaderHeight) {
        this.lastHeaderHeight = headerHeight;
        this.root.style.setProperty('--header-height', `${headerHeight}px`);
        this.root.style.setProperty('--headerHeight', `${headerHeight}px`);
      }
    }

    updateMobileBottomBarMeasurement() {
      const height = Math.round(this.mobileBottomBar?.offsetHeight || 0);
      if (height === this.lastMobileBottomBarHeight) return;

      this.lastMobileBottomBarHeight = height;
      this.root.style.setProperty(
        '--mobileBottomBarHeightGlobal',
        `${height}px`
      );
    }

    updateTotalHeightVariable() {
      const totalHeight =
        Math.max(0, this.lastHeaderHeight) +
        Math.max(0, this.lastAnnouncementHeight);

      this.root.style.setProperty('--totalHeight', `${totalHeight}px`);
    }

    updateFullLayout() {
      if (!this.header) return;

      this.applyPermanentStickyState();
      this.updateAnnouncementMeasurement();
      this.updateHeaderMeasurements();
      this.updateMobileBottomBarMeasurement();
      this.updateTotalHeightVariable();
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.scheduleFullLayoutUpdate);
      window.removeEventListener('load', this.scheduleFullLayoutUpdate);
      document.removeEventListener('shopify:section:load', this.scheduleFullLayoutUpdate);
      document.removeEventListener('shopify:section:select', this.scheduleFullLayoutUpdate);
      this.removeEventListener('preventHeaderReveal', this.applyPermanentStickyState);
      this.resizeObserver?.disconnect();
      this.announcementObserver?.disconnect();

      if (this.layoutFrame) cancelAnimationFrame(this.layoutFrame);

      this.isInitialized = false;
    }

    /* Compatibility methods used by existing theme scripts. */
    hide() {
      this.applyPermanentStickyState();
    }

    reveal() {
      this.applyPermanentStickyState();
    }

    reset() {
      this.applyPermanentStickyState();
    }

    closeMenuDisclosure() {
      this.disclosures =
        this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal =
        this.searchModal || this.header.querySelector('details-modal');

      if (this.searchModal) this.searchModal.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();
})();
